import React, { useState } from 'react';

import Login from '../authentication-pages/Login.jsx';
import Signup from '../authentication-pages/SignUp.jsx';

import './AccessManagementAuthorization.css'

const AccessManagementAuthorization = () => {
    const [authView, setAuthView] = useState('login');

    return (
        authView === 'login'
            ? <Login navigatedFrom='invite' onSwitchToSignup={() => setAuthView('signup')} />
            : <Signup navigatedFrom='invite' onSwitchToLogin={() => setAuthView('login')} />
    )
};

export default AccessManagementAuthorization;
